<template>
  <div>
    <div class="title-bar clearfix">
      <div class="module pull-left">
        {{$t("report.title")}}
      </div>
      <div class="btn-group pull-right">
        <el-button v-if="canExport" class="sm-hidden" :plain="true" size="mini" @click="exportReport" :loading="exportLoading">{{ $t("export") }}
          <i class="fa fa-download"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="refresh">{{ $t("refresh") }}
          <i class="fa fa-refresh"></i>
        </el-button>
        <el-button :plain="true" size="mini" @click="searchDialogVisible=true">{{ $t("search") }}
          <i class="fa fa-search"></i>
        </el-button>
      </div>
    </div>
    <div class="data-list" v-loading="loading" element-loading-text="Loading">
      <el-table border stripe :data="reportInfos" size="mini" class="customer-table">
        <el-table-column :show-overflow-tooltip="true" prop="EANcode" align="center" :resizable="true" :label="this.$t('report.eanCode')" width="200">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="ProductSerials" align="center" :resizable="true" :label="this.$t('report.productSerials')" width="150">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="ProductLongCode" align="center" :resizable="true" :label="this.$t('report.productLongCode')" width="150">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="AmountPerPackage" align="center" :resizable="true" :label="this.$t('report.amountPerPackage')" width="150">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="QRCode1" align="center" :resizable="true" :label="this.$t('report.qrc1')" width="150">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="QRCode2" align="center" :resizable="true" :label="this.$t('report.qrc2')" width="150">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="OrderNumber" align="center" :resizable="true" :label="this.$t('report.orderNumber')" width="150">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="BatchNumber" align="center" :resizable="true" :label="this.$t('report.batchNumber')" width="150">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="UserType" align="center" :resizable="true" :label="this.$t('report.customerType')" width="160" :formatter="customerTypeFormatter">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="ChannelAccount" align="center" :resizable="true" :label="this.$t('report.customerNumber')" width="150">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="ChannelName" align="center" :resizable="true" :label="this.$t('report.customerName')" width="200">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="SaleAreasString" align="center" :resizable="true" :label="this.$t('report.salesAreas')" width="200">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="OrderProductCount" align="center" :resizable="true" :label="this.$t('report.orderCount')" width="120">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="DeliveryTime" align="center" :resizable="true" :label="this.$t('report.deliveryTime')" :formatter="timeFormatter" width="200">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="Office" align="center" :resizable="true" :label="this.$t('report.customerOffice')" width="200">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="OrderProductCount" align="center" :resizable="true" :label="this.$t('report.deliveryCount')" width="120">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="ScanCount" align="center" :resizable="true" :label="this.$t('report.scanCount')" width="150">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" align="center" :resizable="true" :label="this.$t('delivery.hasReceived')" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.ReceivedTime">已领取</span>
            <span v-else>未领取</span>
          </template>
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="ReceivedTime" align="center" :resizable="true" :label="this.$t('report.receivedTime')" :formatter="receivedTimeFormatter" width="200">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" prop="Bonus" align="center" :resizable="true" :label="this.$t('report.bonus')" width="120">
        </el-table-column>

        <el-table-column :show-overflow-tooltip="true" align="center" :resizable="true" :label="this.$t('report.receiveAddress')" min-width="120">
          <template slot-scope="scope">
            {{fullAddress(scope.row.Address)}}
          </template>
        </el-table-column>
      </el-table>

      <el-row class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex" :page-sizes="[15, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-row>
    </div>

    <!-- search dialog -->
    <el-dialog class="search-dialog" :title="this.$t('search')" :visible.sync="searchDialogVisible" width="760px">
      <el-form class="search-form" :model="filter" :inline="true" size="small" label-width="100px">
        <el-form-item :label="this.$t('report.eanCode')" size="small">
          <el-input v-model="filter.EANcode"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('report.productSerials')" size="small">
          <el-input v-model="filter.ProductSerials"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('report.productLongCode')" size="small">
          <el-input v-model="filter.ProductLongCode"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('report.customerName')" size="small">
          <el-input v-model="filter.ChannelName"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('report.qrc1')" size="small">
          <el-input v-model="filter.QRCode1"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('report.qrc2')" size="small">
          <el-input v-model="filter.QRCode2"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('report.customerNumber')" size="small">
          <el-input v-model="filter.ChannelAccount"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('report.orderNumber')" size="small">
          <el-input v-model="filter.OrderNumber"></el-input>
        </el-form-item>

        <el-form-item :label="this.$t('delivery.hasReceived')" size="small">
          <el-radio v-model="filter.hasReceived" label="true">已领取</el-radio>
          <el-radio v-model="filter.hasReceived" label="false">未领取</el-radio>
          <el-radio v-model="filter.hasReceived" label="all">所有</el-radio>
        </el-form-item> <br>

        <el-form-item :label="this.$t('report.deliveryTime')" size="small">
          <el-date-picker v-model="filter.StartDeliveryTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="this.$t('to')" size="small">
          <el-date-picker v-model="filter.EndDeliveryTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="this.$t('report.receivedTime')" size="small">
          <el-date-picker v-model="filter.StartReceivedScanTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="this.$t('to')" size="small">
          <el-date-picker v-model="filter.EndReceivedScanTime" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>

      </el-form>

      <div slot="footer" class="search-footer">
        <el-button @click="searchDialogVisible = false" :plain="true" size="mini">{{this.$t('cancel')}}</el-button>
        <el-button @click="resetFilter" :plain="true" size="mini">{{this.$t('reset')}}</el-button>
        <el-button type="primary" @click="search" :plain="true" size="mini">{{this.$t('confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import roleTypes from "../../../models/roleTypes";
import searchTypes from "../../../models/searchTypes";
import searchHistoryService from "../../../services/searchHistoryService";
import userTypes from "../../../models/userTypes";
import fileSaver from "file-saver";
import { mapGetters } from "vuex";
export default {
  name: "Report",
  data() {
    return {
      searchDialogVisible: false,
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
      reportInfos: [],
      loading: true,
      exportLoading: false,
      filter: {
        hasReceived: "all"
      },
      filterOptions: []
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.pageIndex === 1) {
        this.getReportInfo();
      } else {
        this.pageIndex = 1;
      }
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getReportInfo();
    },
    getReportInfo() {
      this.loading = true;
      let params = {
        filter: JSON.stringify(this.filterOptions),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$axios
        .get("api/report", { params })
        .then(res => {
          this.totalCount = res.data.TotalCount;
          this.reportInfos = res.data.Data;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    exportReport() {
      this.exportLoading = true;
      let params = {
        filter: JSON.stringify(this.filterOptions)
      };
      this.$axios
        .get(`api/report/export`, { params })
        .then(res => {
          let fileName = decodeURIComponent(
            res.headers["file-name"] || "report.csv"
          );
          let BOM = "\ufeff";
          let blob = new Blob([BOM + res.data]);
          fileSaver.saveAs(blob, fileName);
          this.exportLoading = false;
        })
        .catch(e => {
          this.exportLoading = false;
        });
    },
    search() {
      this.searchDialogVisible = false;
      this.setFilterOptions();
      searchHistoryService.setHistory(
        searchTypes.REPORT_HISTORY,
        this.filterOptions
      );
      this.getReportInfo();
    },
    resetFilter() {
      this.pageIndex = 1;
      this.filter = {};
      this.filterOptions = [];
      searchHistoryService.removeHistory(searchTypes.REPORT_HISTORY);
    },
    setFilterOptions() {
      this.filterOptions = [];
      Object.keys(this.filter).forEach(k => {
        let val = this.filter[k];
        if (typeof val === "number" || val) {
          this.filterOptions.push({ name: k, value: val });
        }
      });
    },
    refresh() {
      this.resetFilter();
      this.getReportInfo();
    },
    initializeFilter() {
      let his = searchHistoryService.getHistory(searchTypes.REPORT_HISTORY);
      if (his) {
        let keys = Object.keys(this.filter);
        his.forEach(h => {
          if (keys.includes(h.name)) {
            this.filter[h.name] = h.value;
          }
        });
        this.setFilterOptions();
      }
    },
    fullAddress({ Province, City, Location }) {
      if (Province || City || Location) {
        return `${Province ? Province : ""} ${City ? City : ""} ${
          Location ? Location : ""
        }`;
      } else {
        return "--";
      }
    },
    receivedTimeFormatter(row, col, val) {
      if (val) {
        return this.timeFormatter(row, col, val);
      }
      return this.$t("delivery.notReceived");
    },
    customerTypeFormatter(row, col, val) {
      return userTypes[val];
    }
  },
  computed: {
    ...mapGetters(["roles", "permissions", "token"]),
    canExport() {
      return (
        this.roles.includes(roleTypes.Administrator) ||
        this.permissions.find(p => p.toLowerCase() === "report.export")
      );
    }
  },
  created() {
    this.initializeFilter();
    this.getReportInfo();
  }
};
</script>

<style lang="scss" scoped>

</style>









// WEBPACK FOOTER //
// src/components/application/Report/Report.vue